export function getTranslatedErrors(
  error: string,
  t: (key: string) => string
): string {
  let errorTranslated = "";

  if (error === "User two-factor authentication has expired") {
    errorTranslated = t("twoFactorAuthExpired");
  } else if (error === "Invalid token") {
    errorTranslated = t("invalidToken");
  } else if (error === "Access token is not valid") {
    errorTranslated = t("accessTokenNotValid");
  } else if (error === "Schema not found in database") {
    errorTranslated = t("schemaNotFoundInDatabase");
  } else if (error === "Domain not found in database") {
    errorTranslated = t("domainNotFoundInDatabase");
  } else if (
    error === "User not found - Contact administrator to create an account"
  ) {
    errorTranslated = t("userNotFoundContactAdministrator");
  } else if (
    error ===
    "User has been deactivated - Contact administrator to restore the account"
  ) {
    errorTranslated = t("userDeactivatedContactAdministrator");
  } else if (error === "User two-factor authentication is not enabled") {
    errorTranslated = t("twoFactorAuthNotEnabled");
  } else if (error === "User two-factor authentication has expired") {
    errorTranslated = t("twoFactorAuthExpired");
  } else if (error === "Access token is not valid") {
    errorTranslated = t("invalidToken");
  }

  return errorTranslated;
}
